export var computeStatutorySurcharge = function (age, tariff) {
    if (tariff === 'HiMedical' || tariff === 'HiMedicalPlus') {
        return 0;
    }
    return age >= 21 && age <= 60 ? 0.1 : 0;
};
